import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/mine/null.png'


const _withScopeId = n => (_pushScopeId("data-v-10b280c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message bx" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "全部视频", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "top-title" }
const _hoisted_8 = { class: "item-content" }
const _hoisted_9 = {
  key: 1,
  class: "null"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "null-img"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "暂无数据～", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

import { MessageFetch } from '@/api/request';
import { ISjqnwArticleProps, PaginationProps } from '@/api/type';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import config from '../_config';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

const loading = ref<boolean>(false);
const finished = ref<boolean>(false);
const pagination = ref<PaginationProps>({
  pageNum: 0,
  pageSize: 5
});
// const list = ref<ISjqnwArticleProps[]>([]);
const list = [
  {
    articleTitle: '上进青年环广东省接力赛',
    intro:
      '上进青年的跑步狂欢，华南地区规模最大的环广东省跑步接力，向社会各界传播上进文化',
    coverUrl:
      'https://yzims.oss-cn-shenzhen.aliyuncs.com/shangjinqingnian/1.png',
    videoUrl:
      'https://yzims.oss-cn-shenzhen.aliyuncs.com/shangjinqingnian/%E4%B8%80.mp4'
  },
  {
    articleTitle: '上进青年黄埔天坑公益徒步',
    intro: '上进青年携手徒步，打卡黄埔天坑，为黄埔区美丽的绿水青山增添活力',
    coverUrl:
      'https://yzims.oss-cn-shenzhen.aliyuncs.com/shangjinqingnian/2.png',
    videoUrl:
      'https://yzims.oss-cn-shenzhen.aliyuncs.com/shangjinqingnian/%E4%BA%8C.mp4'
  },
  {
    articleTitle: '南方小记者：321上进文化节 发现上进的力量',
    intro:
      '321上进文化节盛大开幕，南方日报，广东广播电视台，广东少儿频道纷纷报道',
    coverUrl:
      'https://yzims.oss-cn-shenzhen.aliyuncs.com/shangjinqingnian/3.png',
    videoUrl:
      'https://yzims.oss-cn-shenzhen.aliyuncs.com/shangjinqingnian/%E4%B8%89.mp4'
  },
  {
    articleTitle: '小人物的上进故事',
    intro: '每一段往事，都有一段故事，戴世彩的上进故事',
    coverUrl:
      'https://yzims.oss-cn-shenzhen.aliyuncs.com/shangjinqingnian/4.png',
    videoUrl:
      'https://yzims.oss-cn-shenzhen.aliyuncs.com/shangjinqingnian/%E5%9B%9B.mp4'
  },
  {
    articleTitle: '广州无痕山野公益行',
    intro: '上进青年携手社会各界有志青年清洁山野的公益活动',
    coverUrl:
      'https://yzims.oss-cn-shenzhen.aliyuncs.com/shangjinqingnian/5.png',
    videoUrl:
      'https://yzims.oss-cn-shenzhen.aliyuncs.com/shangjinqingnian/%E4%BA%94.mp4'
  },
  {
    articleTitle: '成人亦是达己',
    intro:
      '上进是什么？上进是爱国、爱家、爱企业。成就他人便等于成就自己的价值观，将给我们带来巨大的行动力量，在学习中总会遇到太多的困难需要克服。而如何在未来让自己保持巨大的能量，那么时刻保持上进的行为习惯与思想意识便至关重要。',
    coverUrl:
      'https://yzims.oss-cn-shenzhen.aliyuncs.com/shangjinqingnian/%E5%B0%81%E9%9D%A21%E6%A8%AA%E5%9B%BE.png',
    videoUrl:
      'https://yzims.oss-cn-shenzhen.aliyuncs.com/shangjinqingnian/%E8%A7%86%E9%A2%91.mp4'
  }
];

const onLoad = async() => {
  // 异步更新数据
  loading.value = true;

  pagination.value.pageNum += 1;
  const params = {
    pageNum: pagination.value.pageNum,
    pageSize: pagination.value.pageSize,
    sjqnwArticleType: '1'
  };

  const res = await MessageFetch.getArticleList(params);
  const body = res.body.data;
  if (Array.isArray(body)) {
    list.value = list.value.concat(body);
    // 加载状态结束
    loading.value = false;

    // 到底了
    if (body.length === 0 || body.length < pagination.value.pageSize) {
      finished.value = true;
    }
  }
  if (!body) {
    finished.value = true;
  }
};
const toArticle = (item: ISjqnwArticleProps) => {
  console.log(item);
  router.push({
    name: 'videoDes',
    query: item
  });
};
const toTop = () => {
  let top = document.documentElement.scrollTop || document.body.scrollTop;
  // 实现滚动效果
  const timeTop = setInterval(() => {
    document.body.scrollTop = document.documentElement.scrollTop = top -= 100;
    if (top <= 0) {
      clearInterval(timeTop);
    }
  }, 10);
};
onMounted(() => {
  //   onLoad();
  toTop();
});

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (list.length > 0)
        ? (_openBlock(), _createBlock(_component_van_list, {
            key: 0,
            finished: finished.value,
            "finished-text": "没有更多了",
            onLoad: onLoad,
            class: "active-list"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item) => {
                return _createElementVNode("div", {
                  class: "item",
                  onClick: ($event: any) => (toArticle(item)),
                  key: item.articleTitle
                }, [
                  _createElementVNode("img", {
                    src: item.coverUrl,
                    class: "left"
                  }, null, 8, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.articleTitle), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.intro), 1)
                  ])
                ], 8, _hoisted_4)
              }), 64))
            ]),
            _: 1
          }, 8, ["finished"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
    ])
  ]))
}
}

})